/// <reference types="@angular/localize" />
/// <reference types="@types/googlemaps" />

import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ResourceLoader } from '@angular/compiler';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { CustomCachedResourceLoader } from './app/core/custom-resource.loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [
    {
      provide: ResourceLoader,
      useFactory: (injector: Injector) => new CustomCachedResourceLoader(injector),
      deps: [Injector],
    }
  ],
}).catch(err => console.error(err));
